import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * WomensHealth icon
 *
 * @category Medical
 */
const WomensHealth = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M23.76 11.97c-.05-1.54-.53-3.08-1.42-4.34-1.66-2.33-4.48-3.5-7.28-3.24-2.31.21-4.48 1.54-5.71 3.51-1.28 2.04-1.51 4.69-.67 6.95s2.74 4.08 5.01 4.9c.4.14.82.26 1.17.5s.64.63.61 1.05c-.04.73-.91 1.11-1.64 1.09-.65-.02-1.68-.24-2.34-.09-.35.08-.71.3-.37.77.11.15.32.19.51.21q1.095.105 2.19 0c.45-.04 1.2-.22 1.44.16.36.56.3 1.31.24 2.04-.06.69.03 1.4.26 2.05.06.16.17.35.34.32.14-.02.21-.18.25-.32.19-.68.27-1.39.21-2.1-.04-.54-.03-1.04.07-1.57.13-.71.65-.79 1.38-.68s1.9.04 2.67-.07c.13-.02.44-.17.45-.3.04-.32-.39-.45-.71-.46-.75-.02-1.5-.04-2.25-.05-.58-.01-1.27-.1-1.53-.62-.22-.44.02-.99.4-1.31s.87-.45 1.33-.63c2.08-.78 3.86-2.38 4.75-4.41.46-1.05.67-2.21.64-3.36m-14.235.23c0-3.83 2.614-6.555 6.444-6.555s6.37 2.725 6.37 6.555-2.54 6.61-6.37 6.61-6.444-2.78-6.444-6.61"
        />
      </svg>
    );
  }
);

WomensHealth.displayName = 'WomensHealth';

export { WomensHealth };
